import React, { useState } from 'react';
import { ShieldCheck, Clock, ShieldAlert } from 'lucide-react';
import { useBreadcrumbs } from '@/client/hooks/use-breadcrumbs';
import {
  ReviewQueuePanel,
  ReportedQueuePanel,
} from '@/client/components/admin/ListingManagement/ListingQueues';

type QCTab = 'review' | 'reported';

const ListingQualityControl = () => {
  useBreadcrumbs([
    { label: 'Listing Management', href: '#' },
    { label: 'Quality Control' },
  ]);

  const [tab, setTab] = useState<QCTab>('review');

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="mx-auto max-w-7xl">
        {/* Header */}
        <div className="mb-6 flex items-center gap-3">
          <ShieldCheck className="h-7 w-7 text-indigo-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Quality Control</h1>
            <p className="text-sm text-gray-500">
              Moderate listings pending review and triage user-reported ones.
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-6 flex gap-1 border-b border-gray-200">
          {([
            { id: 'review', label: 'Review queue', icon: Clock },
            { id: 'reported', label: 'Reported', icon: ShieldAlert },
          ] as const).map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setTab(id)}
              className={`flex items-center gap-2 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
                tab === id
                  ? 'border-indigo-600 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </button>
          ))}
        </div>

        {tab === 'review' ? <ReviewQueuePanel /> : <ReportedQueuePanel />}
      </div>
    </div>
  );
};

export default ListingQualityControl;
